import { useEffect } from 'react'
import parse from 'html-react-parser'

import Container from '@/components/base/container'
import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'
import { useLayoutStore } from '@/store/layout'
import { useLoaderStore } from '@/store/loader'

import { cn } from '@/lib/utils'
import { WPPage } from '@/types'

type SimplePageProps = {
  pageProps: WPPage & {
    acf: {
      text?: string
      apertura?: string
      address?: string
      contacts?: string
      iframe_url?: string
    }
  }
}

const SimplePage = ({ pageProps }: SimplePageProps) => {
  const { strings } = useStore()
  const setLoaderState = useLoaderStore((state) => state.setLoaderState)
  const setLayoutState = useLayoutStore((state) => state.setLayoutState)
  const { footer } = strings || {}

  useEffect(() => {
    setLoaderState({ heroCanPlay: true })
    setLoaderState({ isPosterReady: true })
  }, [setLoaderState])

  useEffect(() => {
    setLayoutState({ viewLogo: true, footerVisible: false })

    return () => {
      setLayoutState({ viewLogo: false, footerVisible: false })
    }
  }, [setLayoutState])

  return (
    <div className="flex w-full flex-col bg-black">
      <Container className="pb-[50px] pt-[90px] md:pb-[245px] md:pt-[180px]">
        <div className="flex flex-col gap-10">
          {pageProps?.title?.rendered ? (
            <Typography
              component="h1"
              className="text-center text-[3.6rem] font-light leading-[1] md:text-[7.2rem]"
            >
              {pageProps?.title?.rendered}
            </Typography>
          ) : null}
          {pageProps?.content?.rendered ? (
            <div className="simple-text">
              {parse(pageProps?.content?.rendered)}
            </div>
          ) : null}
        </div>
      </Container>
      <div className="flex w-full px-[4rem] py-[3.6rem]">
        <Typography
          className={cn(
            'flex text-[1.28rem] capitalize tracking-[0.0384rem]',
            'text-white/50'
          )}
          data-motion-colophon
        >
          {footer?.colophon.replace('[YEAR]', new Date().getFullYear())}
        </Typography>
      </div>
    </div>
  )
}

export default SimplePage
